// §VII / §IV деривации — детерминированные строковые операции (spec §8).
//
// Из ОДНОЙ выбранной цитаты (Q2: один selection, деривации программно, без
// доп. LLM-вызовов). Зависят от пунктуации; голос приходит уже чищеным (§1.2),
// но функции устойчивы к её отсутствию (мягкая деградация).

/** Предложения по разделителям .!? (сами разделители сохраняются). */
function sentences(quote) {
  if (!quote) return [];
  const parts = quote.match(/[^.!?]+[.!?]*/g) || [];
  return parts.map((s) => s.trim()).filter(Boolean);
}

/**
 * §VII Slot A epigraph (A4): split по предложениям → 1–5 italic-строк.
 * Нет пунктуации → один цельный спан (одна строка).
 */
export function splitLines(quote) {
  const s = sentences(quote);
  if (s.length === 0) {
    const t = (quote ?? '').trim();
    return t ? [t] : [];
  }
  return s.slice(0, 5);
}

/** §VII Slot F CTA (A6): последнее предложение verbatim. */
export function lastSentence(quote) {
  const s = sentences(quote);
  if (s.length) return s[s.length - 1];
  return (quote ?? '').trim();
}

/**
 * §VII Slot C caption (A5): tiered extraction —
 * Tier 1 post-em-dash → Tier 2 post-comma → Tier 3 last sentence.
 */
export function tieredExtraction(quote) {
  const t = (quote ?? '').trim();
  if (!t) return '';

  const em = Math.max(t.lastIndexOf('—'), t.lastIndexOf('–'));
  if (em !== -1 && em < t.length - 1) {
    const after = t.slice(em + 1).trim();
    if (after) return after;
  }

  const comma = t.lastIndexOf(',');
  if (comma !== -1 && comma < t.length - 1) {
    const after = t.slice(comma + 1).trim();
    if (after) return after;
  }

  return lastSentence(t);
}
